// ==============================|| MENU ITEMS ||============================== //
// Super Administrador
import contable from "./superadmin/contable";
import administracion from "./superadmin/administracion";

// Administrador
import administracionAdmin from "./admin/administracionAdmin";

// User Administrador
import compania from "./userAdmin/compania";
import usuario from "./userAdmin/usuario";
import efectivo from "./userAdmin/efectivosEquivalentes";
import cliente from "./userAdmin/cliente";
import proveedor from "./userAdmin/proveedor";
import compra from "./userAdmin/compra";
import producto from "./userAdmin/producto";
import inventario from "./userAdmin/inventario";
import produccion from "./userAdmin/produccion";
import venta from "./userAdmin/venta";
import contabilidad from "./userAdmin/contabilidad";
import auditoria from "./userAdmin/auditoria";
import userAdministracion from "./userAdmin/userAdministracion";
import transportistas from "./userAdmin/transportistas";
import logs from "./userAdmin/logs";
import databases from "./userAdmin/databases";
import reportes from "./userAdmin/reportes";
import arcsa from "./userAdmin/arcsa";
import arcsaRecepcion from "./userAdmin/arcsa_recepcion";
import notificaciones from "./userAdmin/notificaciones";

// Doctor
import compraDoctor from "./doctor/compra";
import ventaDoctor from "./doctor/venta";
import reportesDoctor from "./doctor/reportes";
import arcsaDoctor from "./doctor/arcsa";

// SuperAdmin
export const superAdminMenuItems = {
    items: [contable, administracion]
};

// Admin de empresas
export const adminMenuItems = {
    items: [administracionAdmin]
};

// Administrador de cada empresa
export const administradorItems = {
    // items: [venta, compra, cliente, proveedor, inventario, producto, contabilidad, compania, efectivo, auditoria, suministros, activos]
    items: [venta, compra, cliente, proveedor, inventario, produccion, producto, contabilidad, compania, userAdministracion, reportes, transportistas, logs, databases, arcsa, arcsaRecepcion, notificaciones]
};

// Contable
export const contableItems = {
    items: [compra, contabilidad, auditoria]
};

// Cajas
export const cajaItems = {
    items: [venta]
};

// Doctor
export const doctorItems = {
    items: [ventaDoctor, compraDoctor, inventario, reportesDoctor, arcsaDoctor]
};

// Pruebas Items
export const menuItems = {
    items: [compania, usuario, efectivo, cliente, proveedor, compra, producto, inventario, venta, contabilidad, auditoria]
};

export default menuItems;
